import { customizeError } from '@chilecompra/react-kit'
import { makeActionCreator } from '../../config/store/utils'
import { getHistoricalContracts } from '../../services/contract'

export const OPEN_HISTORICAL_CONTRACTS_DIALOG = 'OPEN_HISTORICAL_CONTRACTS_DIALOG'
export const CLOSE_HISTORICAL_CONTRACTS_DIALOG = 'CLOSE_HISTORICAL_CONTRACTS_DIALOG'
export const GET_HISTORICAL_CONTRACTS = 'GET_HISTORICAL_CONTRACTS'
export const GET_HISTORICAL_CONTRACTS_ERROR = 'GET_HISTORICAL_CONTRACTS_ERROR'
export const GET_HISTORICAL_CONTRACTS_SUCCESS = 'GET_HISTORICAL_CONTRACTS_SUCCESS'
export const onOpenHistoricalContractsDialog = makeActionCreator(OPEN_HISTORICAL_CONTRACTS_DIALOG)
export const onCloseHistoricalContractsDialog = makeActionCreator(CLOSE_HISTORICAL_CONTRACTS_DIALOG)
export const onGetHistoricalContracts = makeActionCreator(GET_HISTORICAL_CONTRACTS)
export const onGetHistoricalContractsError = makeActionCreator(GET_HISTORICAL_CONTRACTS_ERROR, 'payload')
export const onGetHistoricalContractsSuccess = makeActionCreator(GET_HISTORICAL_CONTRACTS_SUCCESS, 'payload')
export const onGetHistoricalContractsThunk = payload => async dispatch => {
  dispatch(onGetHistoricalContracts())
  try {
    const { data } = await getHistoricalContracts({
      dni: payload.dni.toUpperCase()
    })

    return dispatch(
      onGetHistoricalContractsSuccess({
        contracts: data?.payload?.map(contract => {
          return {
            dni: contract.codigo,
            publicationDate: contract.fechaPublicacionNota,
            contractId: contract.idContrato,
            contractName: contract.nombreContrato,
            contractScore: contract.notaContrato
          }
        })
      })
    )
  } catch (error) {
    let reason
    switch (error.code) {
      case 401:
        reason = 'UNAUTHORIZED_ERROR'
        break
      case 403:
        reason = 'FORBIDDEN_ERROR'
        break
      default:
        reason = 'SOMETHING_WENT_WRONG_ERROR'
        break
    }

    return dispatch(
      onGetHistoricalContractsError({
        error: customizeError({ originalError: error?.originalError, code: error?.code, reason }).toObject()
      })
    )
  }
}
